const reportsPageES = {
	header: {
		title: "Reportes",
		subtitle: "Como va el negocio, y quienes vuelven.",
		subtitleStaff: "Tus reservas y tus clientes.",
	},
	tabs: {
		sales: "Ventas",
		customers: "Clientes",
	},
	// La barra que muestra una seccion a la vez en el telefono.
	sections: {
		label: "Secciones del reporte",
		overview: "Resumen",
		money: "Dinero",
		bookings: "Reservas",
		changes: "Cambios",
	},
	range: {
		label: "Periodo",
		last7: "Ultimos 7 dias",
		last30: "Ultimos 30 dias",
		last90: "Ultimos 90 dias",
		thisMonth: "Este mes",
		lastMonth: "Mes pasado",
		thisYear: "Este ano",
		custom: "Personalizado",
		from: "Desde",
		to: "Hasta",
		apply: "Aplicar",
		covering: "{{days}} dias",
	},
	granularity: {
		label: "Agrupar por",
		day: "Dia",
		week: "Semana",
		month: "Mes",
	},
	filters: {
		allStaff: "Todo el equipo",
		allSources: "Todos los origenes",
		staff: "Personal",
		source: "Origen",
	},
	sources: {
		online: "En linea",
		manual: "Manual",
		"walk-in": "Sin cita",
	},
	kpis: {
		revenue: "Ingresos",
		revenueHint: "Solo de reservas completadas.",
		projected: "Por venir",
		projectedHint: "Reservado pero aun no completado.",
		averageTicket: "Ticket promedio",
		averageTicketHint: "Ingresos divididos entre reservas completadas.",
		customers: "Clientes",
		customersHint: "Personas distintas que reservaron en el periodo.",
		cancellations: "Cancelaciones",
		cancellationsHint:
			"Cancelaciones hechas durante este periodo, incluidas las de citas que aun no ocurren.",
		cancellationsUnavailableHint: "No se pudo cargar el detalle de cancelaciones esta vez.",
		cancellationsSub: "de {{total}} reservas",
		changes: "Cambios",
		changesHint: "Reservas de este periodo que se movieron a otra hora o se editaron despues de haberse hecho.",
		changesSub: "{{moved}} movidas · {{edited}} editadas",
		completed: "Completadas",
	},
	bookings: {
		title: "Que tan ocupado estuviste",
		subtitle: "Tiempo agendado, no medido",
		total: "Reservas",
		totalHint: "Cada reserva cuya cita cayo en este periodo.",
		totalSub: "{{concluded}} hechas · {{upcoming}} por venir · {{cancelled}} canceladas",
		hours: "Horas reservadas",
		hoursHint:
			"El tiempo que estas citas estaban agendadas a durar. Nada registra cuando empezo o termino un servicio de verdad, asi que una cita que se alargo o a la que nadie llego igual cuenta su bloque completo.",
		hoursSub: "{{done}} ya hechas",
		averageLength: "Duracion promedio",
		averageLengthHint: "Minutos agendados por cita, sin contar cancelaciones.",
		averageLengthSub: "normalmente {{median}}",
		leadTime: "Anticipacion",
		leadTimeHint:
			"Con cuanta anticipacion reserva la gente, tomado del punto medio. Las reservas ingresadas para una hora ya pasada quedan fuera.",
		leadTimeSub: "con cuanta anticipacion reservan",
		visitsPerClient: "Visitas por cliente",
		visitsPerClientHint: "Citas divididas entre la cantidad de personas distintas. Mas de 1 significa que la gente vuelve.",
		visitsPerClientSub: "entre {{clients}} clientes",
		byDay: "Dias mas ocupados",
		byHour: "Horas mas ocupadas",
		hourShare: "{{share}}% de las reservas",
		homeVisits: "Visitas a domicilio",
		homeVisitsCount: "Citas",
		homeVisitsShare: "{{share}}% de las reservas",
		travelTime: "Tiempo de traslado",
		empty: "Aun no hay nada que mostrar.",
		days: {
			mon: "Lunes",
			tue: "Martes",
			wed: "Miercoles",
			thu: "Jueves",
			fri: "Viernes",
			sat: "Sabado",
			sun: "Domingo",
		},
		duration: {
			minutesShort: "{{n}} min",
			hoursShort: "{{n}}h",
			hoursMinutes: "{{h}}h {{m}}m",
			daysShort: "{{n}} dias",
		},
	},
	cancellations: {
		title: "Cancelaciones",
		subtitle: "Cancelaciones hechas durante este periodo",
		count: "Cancelaciones",
		countHint: "Hechas durante este periodo, incluidas las de citas que aun no ocurren.",
		inPeriod: "de {{count}} cancelacion(es)",
		shortNotice: "Con menos de 2 horas",
		shortNoticeHint: "Las que casi no tuviste oportunidad de volver a llenar.",
		ofTotal: "de {{total}}",
		medianNotice: "Aviso habitual",
		medianNoticeHint: "El aviso intermedio que recibiste entre todas las cancelaciones del periodo.",
		cohortRate: "Tasa de las citas de este periodo",
		cohortRateHint:
			"De las citas agendadas dentro de este periodo que ya concluyeron, el porcentaje que se cancelo. Se mueve mas lento que el conteo de arriba, porque solo cuenta cancelaciones cuya cita tambien cayo en este periodo.",
		cohortRatePendingHint:
			"Aun no han concluido suficientes citas en este periodo para calcular una tasa confiable.",
		cohortRateSub: "{{cancelled}} de {{settled}} concluidas",
		byLeadTime: "Por aviso recibido",
		byActor: "Por quien cancelo",
		activityUnavailable:
			"El detalle de cancelaciones aun no esta disponible. Aparecera cuando el nuevo indice termine de crearse.",
		lead: {
			under2h: "Menos de 2 horas",
			under24h: "De 2 a 24 horas",
			under72h: "De 1 a 3 dias",
			over72h: "Mas de 3 dias",
			unknown: "Desconocido",
		},
		actors: {
			customer: "Cliente",
			shop: "Tu o tu personal",
			system: "Automatica",
			unknown: "Desconocido",
		},
		notice: {
			afterStart: "Despues de la hora de inicio",
			minutesNotice: "{{n}} min",
			hoursNotice: "{{n}} horas",
			daysNotice: "{{n}} dias",
		},
	},
	modifications: {
		title: "Cambios en las reservas",
		subtitle: "Citas movidas o editadas despues de haberse hecho",
		count: "Reservas cambiadas",
		countHint:
			"Cambios hechos durante este periodo — movidas a otra hora, o con los servicios editados — contados el dia en que se hizo el cambio, sin importar donde termino la cita.",
		countSub: "{{moved}} movidas · {{edited}} editadas",
		rate: "Tasa de cambios",
		rateHint:
			"Los cambios hechos durante este periodo, medidos contra las reservas que este periodo tuvo. Los dos lados cuentan cosas un poco distintas — un cambio hecho ahora puede mover una cita fuera de estas fechas — asi que leelo como “tantos cambios sobre una agenda de este tamano”. Las canceladas quedan fuera: esas cuentan como cancelaciones, no como cambios.",
		ratePendingHint: "Aun no hay suficientes reservas en este periodo para calcular una tasa confiable.",
		rateSub: "de {{eligible}} reservas",
		shortNotice: "Con menos de 2 horas",
		shortNoticeHint: "Cambiadas casi sin aviso antes de la hora en que iban a correr.",
		medianNotice: "Aviso habitual",
		medianNoticeHint:
			"El aviso intermedio entre todos los cambios del periodo, medido contra la hora que se estaba dejando libre.",
		typicalMove: "Movimiento habitual",
		typicalMoveHint: "Que tan lejos viajo la cita intermedia respecto a la hora para la que se reservo primero.",
		typicalMoveSub: "{{forward}} antes · {{back}} despues",
		repeated: "Movidas mas de una vez",
		repeatedHint: "Reservas que se han reagendado al menos dos veces.",
		movedBeyond: "Movidas fuera de estas fechas",
		/* No "Por aviso recibido": el panel de cancelaciones justo encima, en la
		   misma pestana, ya lleva ese titulo, y dos encabezados identicos a una
		   tarjeta de distancia miden poblaciones distintas. */
		byNotice: "Aviso antes del cambio",
		byMove: "Por que tanto se movio",
		byMoveHint:
			"Medido desde la hora para la que se reservo primero, asi que una reserva movida dos veces muestra la distancia completa. “Hora sin cambios” es una reserva a la que se le editaron los servicios sin tocar el reloj.",
		empty: "Aun no hay nada que mostrar.",
		none: "Nada se movio ni se edito en este periodo.",
		shift: {
			noMove: "Hora sin cambios",
			sameDay: "El mismo dia",
			withinWeek: "Dentro de una semana",
			overWeek: "Mas de una semana",
			unknown: "Sin registrar",
		},
	},
	chart: {
		title: "Ingresos en el tiempo",
		empty: "No hay reservas completadas en este periodo.",
		bookingsLabel: "reservas",
	},
	breakdown: {
		title: "De donde vinieron los ingresos",
		byService: "Por servicio",
		byStaff: "Por personal",
		bySource: "Por origen",
		service: "Servicio",
		staff: "Personal",
		source: "Origen",
		bookings: "Reservas",
		revenue: "Ingresos",
		share: "Porcentaje",
		unassigned: "Sin asignar",
		empty: "Aun no hay nada que mostrar.",
		/* Las listas se detienen en pocas filas y el resto queda detras de un
		   dialogo, para que una tienda con veinte personas vea una tarjeta
		   legible y no una pagina que no termina. */
		showAll: "Ver las {{count}}",
		// Subtitulo del dialogo que abre ese boton, donde "Ver las 20" se leia
		// como una copia muerta del boton y no como un conteo.
		rowCount: "{{count}} entradas",
		andMore: "+{{count}} mas",
		other: "Todo lo demas",
		otherSub: "{{count}} entradas menores combinadas",
		searchRows: "Buscar en esta lista",
		noMatches: "Nada coincide con esa busqueda.",
		close: "Cerrar",
		totalRow: "Total",
	},
	quality: {
		title: "Sobre estos numeros",
		estimated:
			"{{amount}} de este total se calculo con tu lista de servicios actual, no con la reserva misma — cambiara si editas esos precios.",
		missing: "{{count}} reserva(s) no tenian un precio que pudieramos resolver y cuentan como cero.",
		unpriced: "Servicios sin precio definido: {{list}}",
		truncated: "Este periodo tiene mas reservas de las que podemos sumar de una vez. Acorta las fechas para una cifra exacta.",
		allSnapshot: "Cada reserva de este periodo trae su propio precio registrado.",
		unsettled:
			"{{count}} reserva(s) de este periodo aun no ocurren, asi que quedan fuera de la tasa de cancelacion hasta que ocurran.",
		cancellationsUnavailable:
			"No se pudo cargar el detalle de cancelaciones esta vez. La tasa de arriba sigue siendo correcta.",
		concludedByTime:
			"{{count}} reserva(s) cuentan como hechas porque su hora ya paso — las reservas sin cita y las agregadas a mano nunca se marcan completadas solas. Su dinero esta incluido en Ingresos.",
		missingLength:
			"{{count}} reserva(s) no tienen hora de inicio y fin utilizable, asi que quedan fuera de las cifras de horas y duracion.",
		cancellationsTruncated:
			"Hubo mas cancelaciones en este periodo de las que podemos sumar de una vez. Acorta las fechas para una cifra exacta.",
		/* Solo se muestra si el barrido hacia adelante fallo. Normalmente los
		   cambios que empujaron una cita al futuro SI se cuentan, que es justo
		   para lo que existe ese barrido — ver aggregateModifications. */
		modificationsForwardUnavailable:
			"No pudimos revisar las reservas agendadas despues de estas fechas esta vez, asi que pueden faltar cambios que movieron una cita hacia el futuro.",
	},
	customers: {
		search: "Buscar nombre, correo o telefono",
		sort: "Ordenar por",
		sortLastVisit: "Ultima visita",
		sortVisits: "Visitas",
		sortRevenue: "Total gastado",
		sortName: "Nombre",
		name: "Cliente",
		visits: "Visitas",
		lastVisit: "Ultima visita",
		spent: "Total gastado",
		favorite: "Servicio habitual",
		empty: "Aun no hay clientes.",
		emptyHint: "Cuando entren reservas, todos los que te visiten apareceran aqui.",
		emptySearch: "Ningun cliente coincide con esa busqueda.",
		emptySearchHint: "Prueba con parte de un nombre, un correo o un telefono.",
		registered: "Tiene cuenta",
		guest: "Invitado",
		anonymousBucket: "Sin cita sin identificar (agrupados)",
		showing: "Mostrando {{shown}} de {{total}}",
		prev: "Anterior",
		next: "Siguiente",
		noName: "Sin nombre",
		truncated: "Tienes mas reservas de las que podemos leer de una vez, asi que las mas viejas quedan fuera de estos totales.",
	},
	detail: {
		title: "Historial del cliente",
		tabs: {
			summary: "Resumen",
			history: "Reservas",
		},
		visits: "Visitas",
		completed: "Completadas",
		cancelled: "Canceladas",
		upcoming: "Por venir",
		spent: "Total gastado",
		firstVisit: "Primera visita",
		lastVisit: "Ultima visita",
		favoriteService: "Servicio habitual",
		favoriteStaff: "Suele ver a",
		history: "Reservas",
		noHistory: "Este cliente no tiene reservas.",
		close: "Cerrar",
		estimatedFlag: "Estimado con los precios actuales",
		contact: "Contacto",
		email: "Correo",
		phone: "Telefono",
		noContact: "No hay datos de contacto registrados.",
		copy: "Copiar",
		copied: "Copiado",
	},
	status: {
		completed: "Completada",
		confirmed: "Por venir",
		rescheduled: "Movida",
		in_progress: "En curso",
		cancelled: "Cancelada",
		unknown: "Desconocido",
	},
	errors: {
		load: "No pudimos cargar este reporte. Intenta de nuevo.",
		loadCustomers: "No pudimos cargar tu lista de clientes. Intenta de nuevo.",
		loadDetail: "No pudimos cargar el historial de este cliente. Intenta de nuevo.",
		noShop: "Aun no hay un negocio vinculado a tu cuenta.",
		badRange: "Elige una fecha de inicio igual o anterior a la fecha final.",
	},
	retry: "Intentar de nuevo",
	info: "Que significa esto",
};

export default reportsPageES;
